module.exports = __webpack_public_path__ + "38ad7afc51ca6928a736b65fc2c1a485.svg";